(function () {
  if (window.__VARUN_PRODUCT_MODULE_TRACKING_LOADED__) return;
  window.__VARUN_PRODUCT_MODULE_TRACKING_LOADED__ = true;

  var currentScript = document.currentScript;
  var runtimeConfig = window.VarunProductModuleTrackingConfig || {};

  var SOURCE_API_URL = String(
    runtimeConfig.apiUrl
    || (currentScript && currentScript.getAttribute("data-api-url"))
    || "https://api.varunebike.com/ga4/shopify-source?token=1xym1r356X1N5tfOxrvkPrKHUg3SJ8G7"
  ).trim();
  var SOURCE_API_TOKEN = String(
    runtimeConfig.apiToken
    || (currentScript && currentScript.getAttribute("data-api-token"))
    || "1xym1r356X1N5tfOxrvkPrKHUg3SJ8G7"
  ).trim();

  var SOURCE_STATE_KEY = "varun_source_product_pages_v2";
  var SESSION_STATE_KEY = "varun_source_session_v2";
  var VISITOR_STATE_KEY = "varun_source_visitor_v2";
  var CUSTOMER_STATE_KEY = "varun_source_customer_v2";
  var VISIBILITY_THRESHOLD = 0.35;
  var MIN_VISIBLE_DURATION_MS = 1000;
  var SESSION_CONTEXT_RETRY_LIMIT = 3;
  var SESSION_CONTEXT_RETRY_DELAY_MS = 300;
  var RESCAN_DELAYS_MS = [0, 1200, 4000, 9000];
  var DEBUG = !!runtimeConfig.debug;

  var registry = new Map();
  var observer = null;
  var mutationObserver = null;
  var discoveryScheduled = false;

  var KNOWN_MODULES = [
    {
      key: "product-main-buy-area",
      name: "Product Main Buy Area",
      pageKinds: ["product"],
      selectors: [
        "[data-source-module-key='product-main-buy-area']",
        "main form[action*='/cart/add']",
        "product-info form[action*='/cart/add']",
        ".product__info-container form[action*='/cart/add']",
        ".product-form",
        ".product__info-wrapper",
        ".product__info-container",
        ".productView-info"
      ],
      headingIncludes: ["buy", "add to cart"]
    },
    {
      key: "product-features",
      name: "Product Features",
      pageKinds: ["product"],
      selectors: [
        "[data-source-module-key='product-features']",
        ".product-features",
        ".product-features-section",
        ".features-section"
      ],
      headingIncludes: ["product features", "features"]
    },
    {
      key: "why-stands-out",
      name: "Why Stands Out",
      pageKinds: ["product"],
      selectors: [
        "[data-source-module-key='why-stands-out']",
        ".why-stands-out"
      ],
      headingIncludes: ["stands out"]
    },
    {
      key: "spotlight-in-riding",
      name: "Spotlight in Riding",
      pageKinds: ["product"],
      selectors: [
        "[data-source-module-key='spotlight-in-riding']",
        ".spotlight-in-riding"
      ],
      headingIncludes: ["spotlight in riding"]
    },
    {
      key: "assembly-guide",
      name: "Assembly Guide",
      pageKinds: ["product"],
      selectors: [
        "[data-source-module-key='assembly-guide']",
        ".assembly-guide",
        ".ups-assembly"
      ],
      headingIncludes: ["assembly guide"]
    },
    {
      key: "youtuber-video-reviews",
      name: "YouTuber Video Reviews",
      pageKinds: ["product"],
      selectors: [
        "[data-source-module-key='youtuber-video-reviews']",
        "[data-source-module-key='youtube-video-reviews']",
        ".youtuber-video-reviews",
        ".youtube-video-reviews"
      ],
      headingIncludes: ["video reviews", "youtuber reviews", "youtube reviews"]
    },
    {
      key: "why-riders-love-varun",
      name: "Why Riders Love VARUN",
      pageKinds: ["product"],
      selectors: [
        "[data-source-module-key='why-riders-love-varun']",
        "[data-source-module-key='varun-rider-moments']",
        ".why-riders-love-varun",
        ".varun-rider-moments"
      ],
      headingIncludes: ["why riders love", "rider moments"]
    },
    {
      key: "compare-the-lineup",
      name: "Compare The Lineup",
      pageKinds: ["product"],
      selectors: [
        "[data-source-module-key='compare-the-lineup']",
        ".compare-the-lineup"
      ],
      headingIncludes: ["compare the lineup", "compare lineup"]
    },
    {
      key: "product-specs",
      name: "Key Specs At A Glance",
      pageKinds: ["product"],
      selectors: [
        "[data-source-module-key='product-specs']",
        ".product-specs",
        ".ups-spec-grid"
      ],
      headingIncludes: ["key specs at a glance", "specs"]
    },
    {
      key: "customer-reviews",
      name: "Customer Reviews",
      pageKinds: ["product"],
      selectors: [
        "[data-source-module-key='customer-reviews']",
        "#shopify-product-reviews",
        ".shopify-app-block",
        ".jdgm-widget",
        ".okeReviews",
        ".spr-container"
      ],
      headingIncludes: ["customer reviews", "reviews"]
    },
    {
      key: "faqs",
      name: "FAQs",
      pageKinds: ["product"],
      selectors: [
        "[data-source-module-key='faqs']",
        ".faq",
        ".faqs",
        ".faq-section",
        ".accordion"
      ],
      headingIncludes: ["faq", "frequently asked questions"]
    },
    {
      key: "collection-hero-banner",
      name: "Collection Hero Banner",
      pageKinds: ["collection"],
      selectors: [
        "[data-source-module-key='collection-hero-banner']",
        ".collection-banner-section .banner",
        ".collection-banner-section"
      ],
      headingIncludes: []
    },
    {
      key: "collection-intro",
      name: "Collection Intro",
      pageKinds: ["collection"],
      selectors: [
        "[data-source-module-key='collection-intro']",
        ".collection-meta-intro",
        ".collection-hero-seo"
      ],
      headingIncludes: []
    },
    {
      key: "collection-buying-guide",
      name: "Collection Buying Guide",
      pageKinds: ["collection"],
      selectors: [
        "[data-source-module-key='collection-buying-guide']",
        ".cbg__intro",
        ".section-collection-buying-guide .cbg__module"
      ],
      headingIncludes: []
    },
    {
      key: "collection-product-grid",
      name: "Collection Product Grid",
      pageKinds: ["collection"],
      selectors: [
        "[data-source-module-key='collection-product-grid']",
        ".main-collection .collection",
        ".collection__content"
      ],
      headingIncludes: []
    },
    {
      key: "collection-feature-1",
      name: "Collection Feature Story 1",
      pageKinds: ["collection"],
      selectors: [
        "[data-source-module-key='collection-feature-1']",
        "[data-collection-meta-feature='1']"
      ],
      headingIncludes: []
    },
    {
      key: "collection-feature-2",
      name: "Collection Feature Story 2",
      pageKinds: ["collection"],
      selectors: [
        "[data-source-module-key='collection-feature-2']",
        "[data-collection-meta-feature='2']"
      ],
      headingIncludes: []
    },
    {
      key: "collection-feature-3",
      name: "Collection Feature Story 3",
      pageKinds: ["collection"],
      selectors: [
        "[data-source-module-key='collection-feature-3']",
        "[data-collection-meta-feature='3']"
      ],
      headingIncludes: []
    },
    {
      key: "collection-top-picks",
      name: "Collection Top Picks",
      pageKinds: ["collection"],
      selectors: [
        "[data-source-module-key='collection-top-picks']",
        ".section-collection-buying-guide-top-picks .cbgt__module",
        ".cbgt__module"
      ],
      headingIncludes: []
    },
    {
      key: "collection-faq",
      name: "Collection FAQ",
      pageKinds: ["collection"],
      selectors: [
        "[data-source-module-key='collection-faq']",
        ".section-collection-buying-guide-faq .cbgf__module",
        ".cbgf__module"
      ],
      headingIncludes: ["faq"]
    },
    {
      key: "recently-viewed",
      name: "Recently Viewed",
      pageKinds: ["product"],
      selectors: [
        "[data-source-module-key='recently-viewed']",
        "recently-viewed",
        ".recently-viewed"
      ],
      headingIncludes: ["recently viewed"]
    }
  ];

  function log() {
    if (!DEBUG || !window.console || !console.log) return;
    var args = Array.prototype.slice.call(arguments);
    args.unshift("[varun-module-tracking]");
    console.log.apply(console, args);
  }

  function toText(value) {
    return value == null ? "" : String(value).trim();
  }

  function toNumber(value) {
    var num = Number(value);
    return Number.isFinite(num) ? num : 0;
  }

  function nowMs() {
    return Date.now();
  }

  function normalizeUrl(url) {
    try {
      var parsed = new URL(url, window.location.href);
      return parsed.origin + parsed.pathname;
    } catch (error) {
      return toText(url);
    }
  }

  function getCurrentPageUrl() {
    return normalizeUrl(window.location.href);
  }

  function getCurrentPathname() {
    try {
      return String(window.location.pathname || "");
    } catch (error) {
      return "";
    }
  }

  function getCurrentPageKind() {
    var pathname = getCurrentPathname();
    if (pathname.indexOf("/products/") === 0) return "product";
    if (pathname.indexOf("/collections/") === 0) return "collection";
    return "";
  }

  function isTrackablePage() {
    return !!getCurrentPageKind();
  }

  function extractProductHandleFromUrl(url) {
    try {
      var parsed = new URL(url, window.location.href);
      var segments = String(parsed.pathname || "").split("/").filter(Boolean);
      var idx = segments.indexOf("products");
      return idx >= 0 && segments[idx + 1] ? String(segments[idx + 1]) : "";
    } catch (error) {
      return "";
    }
  }

  function slugify(value) {
    return toText(value)
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  }

  function unique(values) {
    var seen = new Set();
    var out = [];
    (Array.isArray(values) ? values : []).forEach(function (value) {
      var text = toText(value);
      if (!text || seen.has(text)) return;
      seen.add(text);
      out.push(text);
    });
    return out;
  }

  function readJsonStorage(storage, key, fallbackValue) {
    try {
      var raw = storage.getItem(key);
      return raw ? JSON.parse(raw) : fallbackValue;
    } catch (error) {
      return fallbackValue;
    }
  }

  function writeJsonStorage(storage, key, value) {
    try {
      storage.setItem(key, JSON.stringify(value));
    } catch (error) {}
  }

  function hasStateData(state) {
    return !!(state && typeof state === "object" && Object.keys(state).length);
  }

  function readSharedState(key, fallbackValue) {
    var localState = readJsonStorage(window.localStorage, key, null);
    if (hasStateData(localState)) {
      writeJsonStorage(window.sessionStorage, key, localState);
      return localState;
    }

    var sessionState = readJsonStorage(window.sessionStorage, key, null);
    if (hasStateData(sessionState)) return sessionState;
    return fallbackValue;
  }

  function readCookie(name) {
    try {
      var prefix = name + "=";
      var items = String(document.cookie || "").split("; ");
      for (var i = 0; i < items.length; i += 1) {
        if (items[i].indexOf(prefix) === 0) return decodeURIComponent(items[i].slice(prefix.length));
      }
    } catch (error) {}
    return "";
  }

  function getGaClientId() {
    var gaCookie = readCookie("_ga");
    if (!gaCookie) return "";
    var parts = gaCookie.split(".");
    if (parts.length >= 4) return parts[2] + "." + parts[3];
    return "";
  }

  function getClientId() {
    var sessionState = getSessionState();
    return toText(sessionState.client_id) || getGaClientId();
  }

  function getSessionState() {
    return readSharedState(SESSION_STATE_KEY, {});
  }

  function getSourceState() {
    return readSharedState(SOURCE_STATE_KEY, {});
  }

  function getCustomerStatus() {
    var state = readJsonStorage(window.localStorage, CUSTOMER_STATE_KEY, {});
    return toNumber(state.purchase_count) > 0 ? "returning_customer" : "new_customer";
  }

  function buildVisitorStatus(clientId, sessionState) {
    if (toText(sessionState.visitor_status)) return toText(sessionState.visitor_status);
    var state = readJsonStorage(window.localStorage, VISITOR_STATE_KEY + ":" + clientId, {});
    return toNumber(state.first_seen_ms) > 0 ? "returning_visitor" : "new_visitor";
  }

  function buildTrafficMeta(url, referrer) {
    var sessionState = getSessionState();
    if (toText(sessionState.traffic_source) || toText(sessionState.traffic_medium)) {
      return {
        traffic_source: toText(sessionState.traffic_source),
        traffic_medium: toText(sessionState.traffic_medium),
        traffic_campaign: toText(sessionState.traffic_campaign),
        traffic_campaign_id: toText(sessionState.traffic_campaign_id),
        traffic_content: toText(sessionState.traffic_content),
        traffic_term: toText(sessionState.traffic_term),
        traffic_click_id: toText(sessionState.traffic_click_id),
        ad_platform: toText(sessionState.ad_platform)
      };
    }

    var parsed = null;
    try {
      parsed = new URL(url, window.location.href);
    } catch (error) {}

    function getQueryParam(key) {
      return parsed && parsed.searchParams ? toText(parsed.searchParams.get(key)) : "";
    }

    var utmSource = getQueryParam("utm_source");
    var utmMedium = getQueryParam("utm_medium");
    var utmCampaign = getQueryParam("utm_campaign");
    var utmId = getQueryParam("utm_id");
    var utmContent = getQueryParam("utm_content");
    var utmTerm = getQueryParam("utm_term");
    var gclid = getQueryParam("gclid");
    var gbraid = getQueryParam("gbraid");
    var wbraid = getQueryParam("wbraid");
    var fbclid = getQueryParam("fbclid");
    var ttclid = getQueryParam("ttclid");
    var msclkid = getQueryParam("msclkid");
    var clickId = gclid || wbraid || gbraid || fbclid || ttclid || msclkid;
    var referrerHost = "";

    try {
      referrerHost = referrer ? String(new URL(referrer).hostname || "") : "";
    } catch (error) {}

    var trafficSource = utmSource;
    var trafficMedium = utmMedium;

    if (!trafficSource) {
      if (gclid || gbraid || wbraid) trafficSource = "google";
      else if (msclkid) trafficSource = "bing";
      else if (fbclid) trafficSource = "facebook";
      else if (ttclid) trafficSource = "tiktok";
      else if (referrerHost) trafficSource = referrerHost;
      else trafficSource = "direct";
    }

    if (!trafficMedium) {
      if (clickId) trafficMedium = "paid";
      else if (referrerHost) trafficMedium = "referral";
      else trafficMedium = "direct";
    }

    var adPlatform = "";
    var sourceLower = trafficSource.toLowerCase();
    if (msclkid || sourceLower.indexOf("bing") >= 0) adPlatform = "bing_ads";
    else if (gclid || gbraid || wbraid || sourceLower.indexOf("google") >= 0) adPlatform = "google_ads";
    else if (fbclid || sourceLower.indexOf("facebook") >= 0 || sourceLower.indexOf("instagram") >= 0 || sourceLower.indexOf("meta") >= 0) adPlatform = "meta_ads";
    else if (ttclid || sourceLower.indexOf("tiktok") >= 0) adPlatform = "tiktok_ads";

    return {
      traffic_source: trafficSource,
      traffic_medium: trafficMedium,
      traffic_campaign: utmCampaign,
      traffic_campaign_id: utmId,
      traffic_content: utmContent,
      traffic_term: utmTerm,
      traffic_click_id: clickId,
      ad_platform: adPlatform
    };
  }

  function getProductContext() {
    var pageUrl = getCurrentPageUrl();
    var pageKind = getCurrentPageKind();
    var pageHandle = pageKind === "product" ? extractProductHandleFromUrl(pageUrl) : "";
    var sourceState = getSourceState();
    var sessionState = getSessionState();
    var productPages = unique((sourceState.product_pages || []).concat(pageUrl ? [pageUrl] : []));
    var visitedPages = unique((sourceState.visited_pages || []).concat(pageUrl ? [pageUrl] : []));
    var handles = unique((sourceState.handles || []).concat(pageHandle ? [pageHandle] : []));
    var referrer = toText(document.referrer);
    var clientId = getClientId();

    return {
      client_id: clientId,
      session_id: toText(sessionState.session_id),
      entry_page: toText(sessionState.entry_page) || pageUrl,
      referrer: referrer,
      page_location: pageUrl,
      primary_source_product_page: pageUrl,
      source_product_pages: productPages,
      source_product_handles: handles,
      source_product_page_count: productPages.length,
      visited_pages: visitedPages,
      visited_page_count: visitedPages.length,
      customer_status: getCustomerStatus(),
      visitor_status: buildVisitorStatus(clientId, sessionState)
    };
  }

  function sendPayload(payload, preferBeacon) {
    if (!SOURCE_API_URL) return;
    var body = JSON.stringify(payload);

    if (preferBeacon && navigator.sendBeacon) {
      try {
        var blob = new Blob([body], { type: "application/json" });
        if (navigator.sendBeacon(SOURCE_API_URL, blob)) return;
      } catch (error) {}
    }

    try {
      fetch(SOURCE_API_URL, {
        method: "POST",
        keepalive: true,
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Source-Token": SOURCE_API_TOKEN
        },
        body: body
      }).catch(function () {});
    } catch (error) {}
  }

  function isTrackableElement(element) {
    if (!element || !element.isConnected) return false;
    if (element.getAttribute("data-source-module-ignore") === "true") return false;
    var rect = element.getBoundingClientRect();
    return rect.width >= 40 && rect.height >= 40;
  }

  function normalizeModuleName(name, key) {
    var nameText = toText(name);
    var keyText = toText(key);
    var nameLower = nameText.toLowerCase();
    var keyLower = keyText.toLowerCase();

    if (
      nameLower === "varun rider moments"
      || nameLower === "why riders love varun"
      || keyLower === "varun-rider-moments"
      || keyLower === "why-riders-love-varun"
    ) {
      return { module_name: "Why Riders Love VARUN", module_key: "why-riders-love-varun" };
    }
    if (
      (nameLower.indexOf("stands out") >= 0 && nameLower.indexOf("why ") === 0)
      || (keyLower.indexOf("why-") === 0 && keyLower.indexOf("-stands-out") > 0)
    ) {
      return { module_name: "Why Stands Out", module_key: "why-stands-out" };
    }
    if (
      nameLower === "youtube video reviews"
      || nameLower === "youtuber video reviews"
      || keyLower === "youtube-video-reviews"
      || keyLower === "youtuber-video-reviews"
    ) {
      return { module_name: "YouTuber Video Reviews", module_key: "youtuber-video-reviews" };
    }
    return {
      module_name: nameText,
      module_key: keyText || slugify(nameText)
    };
  }

  function closestModuleContainer(node) {
    if (!node || !node.closest) return null;
    return node.closest("section, article, [data-section-id], .shopify-section, .product__accordion, .product-block, .product-section, .page-width, div");
  }

  function findHeadingContainer(config) {
    var headings = document.querySelectorAll("h1, h2, h3, h4, h5, [role='heading']");
    for (var i = 0; i < headings.length; i += 1) {
      var heading = headings[i];
      var text = toText(heading.textContent).toLowerCase();
      if (!text) continue;
      for (var j = 0; j < config.headingIncludes.length; j += 1) {
        if (text.indexOf(config.headingIncludes[j]) < 0) continue;
        var container = closestModuleContainer(heading);
        if (isTrackableElement(container)) return container;
      }
    }
    return null;
  }

  function registerModule(element, meta) {
    if (!isTrackableElement(element)) return null;

    var normalized = normalizeModuleName(meta.module_name, meta.module_key);
    var moduleKey = normalized.module_key;
    var moduleName = normalized.module_name || moduleKey;
    if (!moduleKey || !moduleName) return null;

    var current = registry.get(moduleKey);
    if (current && current.element === element) {
      current.module_name = moduleName;
      return current;
    }
    if (current && current.element && current.element.isConnected) return current;

    var state = current || {
      module_key: moduleKey,
      module_name: moduleName,
      module_index: toNumber(meta.module_index),
      visible_since_ms: 0
    };

    state.element = element;
    state.module_key = moduleKey;
    state.module_name = moduleName;
    state.module_index = toNumber(meta.module_index);
    registry.set(moduleKey, state);

    element.setAttribute("data-source-module-key", moduleKey);
    element.setAttribute("data-source-module-name", moduleName);
    if (state.module_index > 0) {
      element.setAttribute("data-source-module-index", String(state.module_index));
    }

    if (observer) observer.observe(element);
    return state;
  }

  function discoverAttributeModules() {
    var nodes = document.querySelectorAll("[data-source-module-key], [data-source-module-name]");
    for (var i = 0; i < nodes.length; i += 1) {
      var node = nodes[i];
      if (!isTrackableElement(node)) continue;
      var key = toText(node.getAttribute("data-source-module-key"));
      var name = toText(node.getAttribute("data-source-module-name"));
      if (!name) {
        name = toText(node.getAttribute("aria-label")) || toText(node.textContent).slice(0, 60);
      }
      registerModule(node, {
        module_key: key || slugify(name),
        module_name: name,
        module_index: toNumber(node.getAttribute("data-source-module-index"))
      });
    }
  }

  function discoverKnownModules() {
    var pageKind = getCurrentPageKind();
    KNOWN_MODULES.forEach(function (config, index) {
      if (Array.isArray(config.pageKinds) && config.pageKinds.length && config.pageKinds.indexOf(pageKind) < 0) {
        return;
      }
      if (registry.has(config.key)) return;

      var element = null;
      for (var i = 0; i < config.selectors.length; i += 1) {
        var node = document.querySelector(config.selectors[i]);
        if (!node) continue;
        element = node.matches("form") ? closestModuleContainer(node) || node : node;
        if (isTrackableElement(element)) break;
        element = null;
      }

      if (!element) {
        element = findHeadingContainer(config);
      }
      if (!element) return;

      registerModule(element, {
        module_key: config.key,
        module_name: config.name,
        module_index: index + 1
      });
    });
  }

  function compareElementsByDomOrder(a, b) {
    if (a === b) return 0;
    if (!a || !b || !a.compareDocumentPosition) return 0;
    var position = a.compareDocumentPosition(b);
    if (position & Node.DOCUMENT_POSITION_FOLLOWING) return -1;
    if (position & Node.DOCUMENT_POSITION_PRECEDING) return 1;
    return 0;
  }

  function normalizeModuleIndexes() {
    var states = Array.from(registry.values()).filter(function (state) {
      return state && isTrackableElement(state.element);
    });

    states.sort(function (left, right) {
      return compareElementsByDomOrder(left.element, right.element);
    });

    states.forEach(function (state, index) {
      state.module_index = index + 1;
      state.element.setAttribute("data-source-module-index", String(state.module_index));
    });
  }

  function observeRegisteredModules() {
    if (observer) return;
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var moduleKey = toText(entry.target && entry.target.getAttribute("data-source-module-key"));
        if (!moduleKey || !registry.has(moduleKey)) return;
        var state = registry.get(moduleKey);
        var visible = !!entry.isIntersecting && Number(entry.intersectionRatio || 0) >= VISIBILITY_THRESHOLD;
        if (visible) {
          if (!state.visible_since_ms) state.visible_since_ms = nowMs();
          return;
        }
        flushState(state, false);
      });
    }, {
      threshold: [0, VISIBILITY_THRESHOLD, 0.75]
    });
  }

  function buildPayload(state, durationMs) {
    var context = getProductContext();
    var traffic = buildTrafficMeta(context.page_location, context.referrer);
    return {
      event_name: "module_duration",
      event_time_ms: nowMs(),
      client_id: context.client_id,
      session_id: context.session_id,
      entry_page: context.entry_page,
      referrer: context.referrer,
      traffic_source: traffic.traffic_source,
      traffic_medium: traffic.traffic_medium,
      traffic_campaign: traffic.traffic_campaign,
      traffic_campaign_id: traffic.traffic_campaign_id,
      traffic_content: traffic.traffic_content,
      traffic_term: traffic.traffic_term,
      traffic_click_id: traffic.traffic_click_id,
      ad_platform: traffic.ad_platform,
      visitor_status: context.visitor_status,
      customer_status: context.customer_status,
      page_location: context.page_location,
      source_product_pages: context.source_product_pages,
      primary_source_product_page: context.primary_source_product_page,
      source_product_handles: context.source_product_handles,
      source_product_page_count: context.source_product_page_count,
      visited_pages: context.visited_pages,
      visited_page_count: context.visited_page_count,
      module_name: state.module_name,
      module_key: state.module_key,
      module_index: state.module_index,
      module_duration_ms: Math.max(0, Math.round(durationMs)),
      page_duration_ms: 0,
      checkout_id: "",
      transaction_id: "",
      currency: "",
      value: 0,
      items: [],
      debug_mode: false
    };
  }

  function scheduleFlushRetry(state, durationMs, preferBeacon, attempt) {
    if (!state || attempt >= SESSION_CONTEXT_RETRY_LIMIT) {
      log("skip module_duration missing session context", state && state.module_key);
      return;
    }
    window.setTimeout(function () {
      sendModuleDuration(state, durationMs, preferBeacon, attempt + 1);
    }, SESSION_CONTEXT_RETRY_DELAY_MS);
  }

  function sendModuleDuration(state, durationMs, preferBeacon, attempt) {
    var payload = buildPayload(state, durationMs);
    if (!toText(payload.client_id) || !toText(payload.session_id)) {
      scheduleFlushRetry(state, durationMs, preferBeacon, attempt || 0);
      return;
    }
    sendPayload(payload, preferBeacon);
  }

  function flushState(state, preferBeacon) {
    if (!state || !state.visible_since_ms) return;
    var durationMs = nowMs() - state.visible_since_ms;
    state.visible_since_ms = 0;
    if (durationMs < MIN_VISIBLE_DURATION_MS) return;
    sendModuleDuration(state, durationMs, preferBeacon, 0);
  }

  function flushAll(preferBeacon) {
    registry.forEach(function (state) {
      flushState(state, preferBeacon);
    });
  }

  function discoverModules() {
    if (!isTrackablePage()) return;
    observeRegisteredModules();
    discoverAttributeModules();
    discoverKnownModules();
    normalizeModuleIndexes();
    registry.forEach(function (state) {
      if (observer && isTrackableElement(state.element)) observer.observe(state.element);
    });
    log("modules", Array.from(registry.values()).map(function (item) {
      return { key: item.module_key, name: item.module_name, index: item.module_index };
    }));
  }

  function scheduleDiscovery() {
    if (discoveryScheduled) return;
    discoveryScheduled = true;
    window.requestAnimationFrame(function () {
      discoveryScheduled = false;
      discoverModules();
    });
  }

  function startMutationObserver() {
    if (mutationObserver || !window.MutationObserver) return;
    mutationObserver = new MutationObserver(function () {
      scheduleDiscovery();
    });
    mutationObserver.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  function start() {
    if (!isTrackablePage()) return;
    RESCAN_DELAYS_MS.forEach(function (delayMs) {
      window.setTimeout(discoverModules, delayMs);
    });
    startMutationObserver();

    document.addEventListener("visibilitychange", function () {
      if (document.hidden) flushAll(true);
      else discoverModules();
    });
    window.addEventListener("pagehide", function () {
      flushAll(true);
    });
    window.addEventListener("beforeunload", function () {
      flushAll(true);
    });
    document.addEventListener("shopify:section:load", scheduleDiscovery);
    document.addEventListener("shopify:section:reorder", scheduleDiscovery);
    document.addEventListener("shopify:block:select", scheduleDiscovery);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, { once: true });
  } else {
    start();
  }
})();
